import type { SkillProfile } from './aiSkill';

/** Runtime assistance, never written into a character or its difficulty progression. */
export const HUMAN_FRIENDLY_AI = {
  reactionDelay: 0.1,
  aimSpread: 1.25,
  movement: 0.9,
  lead: 0.8,
} as const;

export function humanFriendlyProfile(profile: SkillProfile): SkillProfile {
  return {
    ...profile,
    reaction: profile.reaction + HUMAN_FRIENDLY_AI.reactionDelay,
    aimSpread: profile.aimSpread * HUMAN_FRIENDLY_AI.aimSpread,
    lead: profile.lead * HUMAN_FRIENDLY_AI.lead,
  };
}
